export default __webpack_public_path__ + "static/media/placeholder_portfolio02-fr-web.fc86f3f1.png";